const cartState = {
  cartHotel: { isEmpty: true, rooms: [] },
  amount: null,
  isUpdating: false,
  errorCode: null,
  is_custom_currency_rate: false,
  custom_currency_code: null,
  default_confirm_country: null,
};

export const shoppingCartToCart = (apiCart) => {
  // We do not use the API "average_amount" as it is calculated per night but is not valid if mixing dates / rooms...
  const hotel = apiCart.hotels.length === 0 ? { isEmpty: true, rooms: [] } : apiCart.hotels[0];
  return {
    cartHotel: hotel,
    amount: apiCart.amount,
    amountBefore: apiCart.amount_before || apiCart.amount,
    is_custom_currency_rate: apiCart.is_custom_currency_rate,
    custom_currency_code: apiCart.custom_currency_code,
    default_confirm_country: apiCart.default_confirm_country,
    // Con ésto se soluciona error de no mandar el token en la confirmación de la booking
    budget_token: apiCart.budget_token,
  };
};

// eslint-disable-next-line default-param-last
export const cart = (state = cartState, action) => {
  switch (action.type) {
    case 'CART_CLEAR':
      return cartState;
    case 'CART_SET_ERROR_CODE':
      return { ...state, errorCode: action.errorCode };
    case 'CART_UPDATE_CONTENT':
      // We convert to the data structure in the front
      return { ...state, ...shoppingCartToCart(action.updatedCart) };
    case 'CART_SET_UPDATING':
      return { ...state, isUpdating: action.isUpdating };
    default:
      return state;
  }
};
